<template>
    <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      卡券领取信息
    </van-notice-bar>
    <van-cell title="查看卡券领取信息" is-link @click="toStatement_get" />
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      卡券使用信息
    </van-notice-bar>
    <van-cell title="查看卡券使用信息" is-link @click="toStatement_use" />
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      卡券详情
    </van-notice-bar>
    <van-cell-group>
       <van-cell title="卡券编号" :value="detail.card_num" />
        <van-cell title="卡券名称" :value="detail.title" />
        <van-cell title="卡券颜色" :value="detail.color" />
        <van-cell title="卡券类型" :value="detail.card_type=='FULL_REDUCE'?'满减':'折扣'" />
        <van-cell title="发券数量" :value="detail.num" />
        <van-cell title="限制领取数量" :value="detail.get_limit" />
        <van-cell title="卡券介绍" :label="detail.description" />
        <van-cell title="消费者满多少" :value="detail.consumer_full_money" />
        <van-cell title="消费者减多少" :value="detail.consumer_reduce_money" />
        <van-cell title="商户优惠" :value="detail.merchant_reduce_money" />
        <van-cell title="客服电话" :value="detail.phone" />
        <van-cell title="卡券有效期类型" :value="detail.limit_date_type" />
        <van-cell title="卡券创建日期" :value="detail.create_time" />
        <van-cell title="固定卡券生效日期" :value="detail.limit_began_date" />
        <van-cell title="固定卡券失效日期" :value="detail.limit_end_date" />
        <van-cell title="领取开始时间" :value="detail.get_began_date" />
        <van-cell title="领取结束时间" :value="detail.get_end_date" />
		<van-cell title="适用门店" v-if="typeof this.detail.stores=='string'">
		    <template #label>
		       <div class="store">
		           {{detail.stores}}
		       </div>
		    </template>
		</van-cell>
         <van-cell title="适用门店" v-else>
             <template #label>
                <div class="store" v-for="(item,index) in detail.stores" :key="index">
                    {{item}}
                </div>
             </template>
         </van-cell>
    </van-cell-group>
    </div>
</template>
<script>
export default {
    data(){
        return {
            detail:{}
        }
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        getDetail(){
            this.detail = this.$route.query
            console.log(this.detail);
        },
        toStatement_get(){
            this.$router.push({
                path:'/statement_get',
                query:{id:this.detail.id}
            })
        },
        toStatement_use(){
            this.$router.push({
                path:'/statement_use',
                query:{id:this.detail.id}
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .store{
        // text-align: right;
        margin-bottom:10px;
    }
</style>